import axios from "axios";
// import { getUserAccessToken } from '../session/session.service';
// import { coreAppURL } from '../../config/app.config';
import { getOfficeEndpoint } from "./wopi.config";

const supportedFiles = ["docx", "xlsx", "docx"];
const wopiBaseUrl = process.env.REACT_APP_WOPI_BASE_URL;
const baseUrl = process.env.REACT_APP_BASE_URL;

const getFileExtension = (filename) => {
  return filename
    .slice((Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1)
    .toLowerCase();
};

export const downloadWopiFile = async (key, options = {}, isCore) => {
  const encodedKey = encodeURIComponent(key);
  const accessToken = sessionStorage.getItem("accessToken");
  const headers = { Authorization: `${accessToken}` };
  try {
    const res = await axios.get(`${baseUrl}/customer/getToken`, { headers });
    let response;
    if (isCore === "core") {
      const coreRes = await axios.get(
        `${wopiBaseUrl}/wopi/files/${encodedKey}/contents/?access_token=${res.data}`,
        options
      );
      return response = coreRes.data;
    } else {
      response = await fetch(
        `${baseUrl}/storage/file/download?key=${encodedKey}`,
        { headers }
      );
    }
    const blob = await response.blob();
    return blob;
  } catch (err) {
    console.log("Err: ", err);
  }
};

export const isOfficeFileSupported = (file) => {
  return supportedFiles.includes(getFileExtension(file));
};

export const navigateToOfficeViewer = (key) =>
  window.open(`/docx-viewer/${key}`, "_blank");

const getWopiURL = (file, action) => {
  const extension = getFileExtension(file);
  return getOfficeEndpoint(extension.toLowerCase(), action.toLowerCase());
};

export const getWopiOfficeURL = (file, action) => {
  const url = getWopiURL(file, action);
  return `${url}&WOPISrc=${wopiBaseUrl}/wopi/files/${file}`;
};
